import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./viewAndEdit.css"
const ViewAndEditModalHeader = (props:any) => {

  return (
    <div className="modal-header">
      <p>{props.message}</p>
      <div className="model-header-icon">
        <FontAwesomeIcon
          className="model-sign"
          fontSize="30px"
          icon={faXmark}
          onClick={props.close}
        />
      </div>
    </div>
  );
};

export default ViewAndEditModalHeader;
